export default function TopBar() {
  return (
    <>
      <div className='relative z-[150] bg-gray-950 px-4 py-3 leading-none text-white'>
        <span className='block font-secondary'>
          <span className='text-white'>CERN</span>{' '}
          <span className='text-gray-400'>Accelerating science</span>
        </span>
      </div>
    </>
  );
}
